<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { saleService } from "../../../services/saleservice/sale.service";
import { propertyService } from "../../../services/propertyservice/property.service";
import { projectService } from "../../../services/projectservice/project.service";
import { servicehelpers } from "../../../services/servicehelpers";
import List from "../../../components/list";
import Screen from "../../../components/screen";
import i18n from "../../../i18n";

/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Selling List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      ...Screen.Alert,
      ...Screen.Locate,
      saleData: {},
      typeData: {},
      groupData: {},
      floorData: {},
      projectData: {},
      fetchingStats: false,
      title: "Selling List",

    };
  },
  mounted() {
    /* eslint-disable no-console */
    this.loadingData();
    this.loadingprojectData();
    
    
    // localStorage.map((item) => {
    //   console.log(JSON.stringify(item));
    // });

  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      saleService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.saleData = response;
        });
    },

    deleted: function(id) {
      saleService.remove(id)
        .then(response => {
        
          // this.saleData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    moreClick: function(event, id) {
      if(event == 'writeoff') {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.unkeep-message'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {
            console.log("HHHHHHHHHHHHH", id);

            saleService.remove(id)
            .then(response => {
        
              if(response.status == 200) {
                
                propertyService.update(response.data.property_id, {
                  property_status_id: 1,
                  customer_id: 0
                }).then(response => {
                  if(response.status == 200) {
                    
                    this.$swal.fire({
                      title: i18n.t('general.success.title'),
                      text: i18n.t('general.success.message'),
                      icon: "success",
                      confirmButtonColor: "#34c38f",
                      confirmButtonText: i18n.t('general.success.yes')
                    });

                  }
                });

              }
            });

          }
        });
      } else if(event == 'late-payment') {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.unkeep-message'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {
            console.log("HIIII");
          }
        });
      }
    },

    projectChanged: function(event) {
      this.loadingpropertyFloorData(event);
      this.loadingpropertyGroupData(event);
    },

    loadingprojectData: function() {
      projectService.getList()
        .then(response => {
          this.projectData = response;

        });
    },

    loadingpropertyFloorData: function(projectId = 0) {
      servicehelpers.getFloorData(projectId).then(response => {
        this.floorData = response;
      });
    },

    loadingpropertyGroupData: function(projectId = 0) {
      servicehelpers.getGroupData(projectId).then(response => {
        this.groupData = response;
      });
    },


    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "sale-add",
          });
    },

    //  }, {
    //           name: 'sale.write-off', icon: 'bx bx-x-circle', action: 'writeoff', link: 'property-contract', column: 'id'

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'sale-add'}"
    :title="$t('menuitems.sale.text')" />
    <List v-bind:dataList="saleData" 
          @more="moreClick"
          v-bind:edit="{link: 'sale-edit'}"
          v-bind:deletes="[deleted, null]"
          v-bind:more="{
            sub: [{
              name: 'sale.contract', icon: 'bx bx-file', link: 'property-contract', column: 'id', target: '_blank'
            },{
              name: 'sale.schedule.view', icon: 'bx bx-table', link: 'payment-schedule-sale', column: 'id', target: '_blank'
            }, {
              name: 'sale.commission', icon: 'bx bx-certification', link: 'property-contract', column: 'id'
            }, {
              name: 'sale.transfer-to-other', icon: 'bx bx-transfer-alt', link: 'sale-transfer', column: 'id'
            }, {
              name: 'property.change-term', icon: 'bx bx-money', link: 'change-term', column: 'id'
            }, {
              name: 'booking.reciept', icon: 'bx bx-dollar-circle', link: 'booking-receipt', column: 'booking_id', target: '_blank'
            }, {
              name: 'property.cancelation.text', icon: 'bx bx-block', link: 'property/cancelation', query: 'saleid', column: 'id'
            }, {
              name: 'property.payment', icon: 'bx bx-table', link: 'payment-list', column: 'id'
            }, {
              name: 'sale.late-payment', icon: 'bx bx-time', link: 'sale-late-payment', column: 'id', show: {column: 'payment_status_id', value: 1}
            }, {
              name: 'sale.late-payment', icon: 'bx bx-time', link: 'sale-late-payment', column: 'id', show: {column: 'payment_status_id', value: 2}
            }, {
              name: 'sale.pay-off-certificate', icon:'bx bxs-file-doc', action: '', link: 'property-unkeep', column: 'id', show: {column: 'payment_status_id', value: 3}
            }] 
          }"
          v-bind:filter="{
            search: ['sales.code', 'customers.name', 'customers.name_en', 'properties.code'],
            dropdown: [{
              title: 'property.project',
              field: 'properties.project_id',
              data: this.projectData.data,
              method: (event) => projectChanged(event),
              default: 1,
              width: 2
            }, {
              title: 'property.group',
              field: 'properties.property_group_id',
              data: this.groupData.data,
            }, {
              title: 'property.floor',
              field: 'properties.project_floor_id',
              show: 'number',
              data: this.floorData.data,
            }],
            date: {
              title: 'general.date',
              field: 'sales.sale_date'
            }
          }"
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[{name: 'status', color: true}, {name: 'currency_en'}, {name: 'sale_date', type: 'date'}, {name: 'expire_date', type: 'date'},
                    {name: 'discount', type: 'currency', sign: '$'}, {name: 'sale_price', type: 'currency', sign: '$'}, 
                    {name: 'price', type: 'currency', sign: '$'}, {name: 'deposit', type: 'currency', sign: '$'}]"
          v-bind:fields="[ `code: ${$t('sale.code')}`, `customer: ${$t('customer.text')}`, 
            `property: ${$t('property.text')}`, `sale_date: ${$t('general.date')}`, `status: ${$t('general.status')}`, 
            `price: ${$t('booking.price')}`,
            `discount: ${$t('booking.discount')}`,
            `sale_price: ${$t('sale.sale-price')}`, 
            `deposit: ${$t('booking.deposit')}`, 
            ]" />
  </Layout>
</template>

